export default {"src":"/_next/static/media/ebook.e10c4e26.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};